class GlobalState {
  constructor(initialValue) {
    this.value = initialValue
    this.subscribers = []
  }

  getValue() {
    return this.value
  }

  setValue(newState) {
    // If newState is function, then we need to call it with current state as argument
    if (typeof newState === "function") {
      newState = newState(this.value)
    }
    if (this.getValue() === newState) {
      return
    }
    this.value = newState
    this.subscribers.forEach((subscriber) => {
      subscriber(this.value)
    })
  }

  subscribe(itemToSubscribe) {
    if (this.subscribers.indexOf(itemToSubscribe) > -1) {
      return
    }
    this.subscribers.push(itemToSubscribe)
  }

  unsubscribe(itemToUnsubscribe) {
    this.subscribers = this.subscribers.filter(
      (subscriber) => subscriber !== itemToUnsubscribe
    )
  }
}

export default GlobalState
